import get from 'lodash/get';

function isExperienceComplete(state, key) {
  return get(state, ['ftue', 'experiences', key, 'is_complete'], true);
}

export default isExperienceComplete;
